import { Typography } from '@/components/ui/typography'
import { usePathHelper } from '@/hooks/usePathHelper'
import { Can } from '@/lib/casl'
import { Link } from '@tanstack/react-router'

/** Marks a shop fee on staff screens and leads to the setting that adds it. Never printed. */
export function ShopFeeTag() {
  return (
    <>
      (
      <Can I="list" a="fee-settings" passThrough>
        {(canOpenSettings) => (canOpenSettings ? <ShopFeeSettingsLink /> : 'Shop fee')}
      </Can>
      )
    </>
  )
}

function ShopFeeSettingsLink() {
  const path = usePathHelper()

  return (
    <Typography
      as={Link}
      variant="bodySmall"
      tone="interaction"
      interaction="hoverUnderline"
      {...path.fees.index().link}
    >
      Shop fee
    </Typography>
  )
}
